

import React, { useState, useEffect, useRef } from "react";
import logo from "../../img/mustard_spray.gif";
import { Grid, Icon, Button, Header, Segment } from "semantic-ui-react";
import Draggable from "react-draggable"; // The default
import "./Dashboard.css";
import DijonCard from "./DijonCard";
import Tickets from '../Tickets/Tickets'
import axiosInstance from "../../lib/auth/axiosApi";
import MustardBottleLoader from "../../components/MustardBottleLoader/MustardBottleLoader";
import { randDigit } from "../../lib/utils/utils";

function DijonDice(props) {

  const [randomDigit, setRandomDigit] = useState(null)
  const [generating, setGenerating] = useState(false)

  const generateRandomNumber = () => {
    setGenerating(true)

    try {
      // Use cryptographically secure random number generator
      // with unbiased mapping (rejection sampling)
      const digit = randDigit()
      setRandomDigit(digit)

    } catch (error) {
      console.error('Error generating random number:', error)
      // Fallback to CSPRNG even on error
      try {
        setRandomDigit(randDigit())
      } catch (fallbackError) {
        console.error('Fallback error:', fallbackError)
        setRandomDigit(0)
      }
    }

    setGenerating(false)
  }

  return (
    <div id="dice">
      <DijonCard
        width={'100%'}
        height={'82vh'}
        activeCards={props.activeCards}
        setActiveCards={props.setActiveCards}
        name={'dice'}
        content={
          <div className={"container mx-auto px-4"} style={{
              height: '100%',
              overflow: 'scroll',
              padding: '20px'
          }}>
            <Header as="h2" textAlign="center" style={{ color: '#fff', marginBottom: '30px' }}>
              🎲 Cryptographically Secure Random Number Generator
            </Header>

            <div style={{ textAlign: 'center', marginBottom: '30px' }}>
              <Button
                primary
                size="large"
                onClick={generateRandomNumber}
                loading={generating}
                disabled={generating}
              >
                {generating ? 'Generating...' : 'Generate Random Digit'}
              </Button>
            </div>

            {randomDigit !== null && (
              <Segment style={{ textAlign: 'center', marginBottom: '20px' }}>
                <Header as="h1" style={{ fontSize: '4em', color: '#2185d0', margin: '20px 0' }}>
                  {randomDigit}
                </Header>
                <p style={{ fontSize: '1.2em' }}>Your cryptographically secure random digit (0-9)</p>
              </Segment>
            )}

            <Segment>
              <Header as="h4">How it works:</Header>
              <ul style={{ textAlign: 'left' }}>
                <li><strong>Uses Web Crypto API:</strong> Leverages <code>crypto.getRandomValues()</code> for cryptographically secure randomness</li>
                <li><strong>Unbiased mapping:</strong> Uses rejection sampling to avoid modulo bias</li>
                <li><strong>Rejects biased range:</strong> Values 250-255 are rejected (250 is the largest multiple of 10 ≤ 255)</li>
                <li><strong>True uniformity:</strong> Each digit 0-9 has exactly equal probability</li>
                <li><strong>No Math.random():</strong> Avoids predictable pseudo-random generators</li>
                <li><strong>No arithmetic tricks:</strong> Doesn't rely on multiplication/division which destroys entropy</li>
                <li><strong>Security-grade:</strong> Suitable for cryptographic applications, tokens, and security-sensitive operations</li>
              </ul>
            </Segment>

            <Segment>
              <Header as="h4">Why the old method was insecure:</Header>
              <ul style={{ textAlign: 'left' }}>
                <li><strong>Predictable inputs:</strong> Video frames are deterministic and can be replayed</li>
                <li><strong>Math.random() contamination:</strong> Using Math.random() anywhere ruins cryptographic security</li>
                <li><strong>Floating-point bias:</strong> IEEE-754 float operations introduce correlations and reduce variability</li>
                <li><strong>Arithmetic doesn't create entropy:</strong> Multiplying/dividing numbers doesn't add randomness</li>
                <li><strong>No entropy extraction:</strong> Missing cryptographic hash to properly condition the noise</li>
                <li><strong>No health tests:</strong> No way to detect if the random source fails</li>
              </ul>
            </Segment>

            <Segment>
              <Header as="h4">Technical Details:</Header>
              <p>
                This implementation follows NIST SP 800-90 guidelines for random number generation.
                The rejection sampling approach ensures perfect uniformity without the bias inherent in
                naive modulo operations. For more details, see the{' '}
                <a
                  href="https://developer.mozilla.org/en-US/docs/Web/API/Crypto/getRandomValues"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ color: '#2185d0' }}
                >
                  Web Crypto API documentation
                </a>.
              </p>
            </Segment>
          </div>
        }
      />
    </div>
  );
}

export default DijonDice;
